import { render, staticRenderFns } from "./index.view.vue?vue&type=template&id=6c1327df&scoped=true"
import script from "./index.view.vue?vue&type=script&lang=ts"
export * from "./index.view.vue?vue&type=script&lang=ts"
import style0 from "./index.view.vue?vue&type=style&index=0&id=6c1327df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1327df",
  null
  
)

export default component.exports